const Kumbaya = [
	'[Chorus]',
	'Kum-ba-ya, my lord, kum-ba-ya.',
	'Kum-ba-ya, my lord, kum-ba-ya.',
	'Kum-ba-ya, my lord, kum-ba-ya.',
	'Oh Lord, Kum-ba-ya.',
	'',
	'[Verse 1]',
	"Someone's crying, Lord, Kum ba yah!",
	"Someone's crying, Lord, Kum ba yah!",
	"Someone's crying, Lord, Kum ba yah!",
	'Oh Lord, Kum ba yah',
	'',
	'[Chorus]',
	'Kum-ba-ya, my lord, kum-ba-ya.',
	'Kum-ba-ya, my lord, kum-ba-ya.',
	'Kum-ba-ya, my lord, kum-ba-ya.',
	'Oh Lord, Kum-ba-ya.',
	'',
	'[Verse 2]',
	"Someone's singing, Lord, Kum ba yah!",
	"Someone's singing, Lord, Kum ba yah!",
	"Someone's singing, Lord, Kum ba yah!",
	'Oh Lord, Kum ba yah',
	'',
	'[Chorus]',
	'Kum-ba-ya, my lord, kum-ba-ya.',
	'Kum-ba-ya, my lord, kum-ba-ya.',
	'Kum-ba-ya, my lord, kum-ba-ya.',
	'Oh Lord, Kum-ba-ya.',
	'',
	'[Verse 3]',
	"Someone's praying, Lord, Kum ba yah!",
	"Someone's praying, Lord, Kum ba yah!",
	"Someone's praying, Lord, Kum ba yah!",
	'Oh Lord, Kum ba yah',
	'',
	'[Chorus]',
	'Kum-ba-ya, my lord, kum-ba-ya.',
	'Kum-ba-ya, my lord, kum-ba-ya.',
	'Kum-ba-ya, my lord, kum-ba-ya.',
	'Oh Lord, Kum-ba-ya.',
];

export default Kumbaya;
